import React from 'react'
import clsx from 'clsx'
import { Button, ButtonProps, CircularProgress, useMediaQuery, useTheme } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { withStyles } from '@mui/styles'
import { CircularProgressProps } from '@mui/material/CircularProgress'

import { useProgressButtonStyles } from './CircularProgressButtonStyles'

interface Props extends Omit<ButtonProps, 'children'> {
  text: string
  circularProgress?: CircularProgressProps
}

const CircularProgressButton: React.FC<Props> = (props) => {
  const s = useProgressButtonStyles()
  const theme = useTheme()
  const { circularProgress, text, ...rest } = props
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const StyledButton = withStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '20px',
      borderRadius: '50px',
      textTransform: 'inherit',
      marginBottom: '15px',
      color: props.color === 'secondary' ? theme.palette.common.white : theme.palette.getContrastText(theme.palette.common.white),
      backgroundColor: props.color === 'secondary' ? theme.palette.secondary.main : theme.palette.common.white,
      '&:hover': {
        backgroundColor: props.color === 'secondary' ? theme.palette.secondary.main : theme.palette.common.white,
      },
      padding: props.size === 'small' ? '7px 20px' : '12px 30px',
      width: isMobile || props.size === 'small' ? '280px' : '300px',
      '& .MuiSvgIcon-root': {
        fontSize: '30px',
      },
      '& .MuiButton-label': {
        width: !props.endIcon ? 'auto' : '100%',
        margin: !props.endIcon ? '0 auto' : '',
      },
    },
  }))(Button)

  return <StyledButton
    {...rest}
  >
    <span className={clsx(s.container, props.disabled && s.hideElement)}>
      {text}
    </span>
    <span className={clsx(
      s.container,
      s.circularProgressContainer,
      !props.disabled && s.hideElement,
    )}
    >
      <CircularProgress size={20} thickness={8} {...circularProgress} />
    </span>
  </StyledButton>
}

export default CircularProgressButton
